/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedResponse } from '../../models/paginated-response';

export interface RewardLogsControllerFindAll$Params {
  page?: number;
  limit?: number;

/**
 * Search by volunteer name or reward name
 */
  search?: string;
  userId?: string;
  rewardId?: string;
  sortBy?: 'createdAt' | 'updatedAt' | 'spentPoints' | 'rewardName' | 'volunteerName';
  sortOrder?: 'ASC' | 'DESC';
}

export function rewardLogsControllerFindAll(http: HttpClient, rootUrl: string, params?: RewardLogsControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedResponse>> {
  const rb = new RequestBuilder(rootUrl, rewardLogsControllerFindAll.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('search', params.search, {});
    rb.query('userId', params.userId, {});
    rb.query('rewardId', params.rewardId, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('sortOrder', params.sortOrder, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedResponse>;
    })
  );
}

rewardLogsControllerFindAll.PATH = '/reward-logs';
